import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Leaders {
  name: string;
  api_token: string;
}

export interface LeadersListInfor {
  errors: unknown;
  leaders: Leaders;
  isAuthenticated: boolean;
}

@Module
export default class LeadersModule
  extends VuexModule
  implements LeadersListInfor
{
  errors = {};
  leaders = {} as Leaders;
  isAuthenticated = !!JwtService.getToken();

  get Leaders() {
    return this.leadersListData;
  }

  get LeaderSelect() {
    return this.leadersListSelect;
  }

  @Mutation
  [Mutations.LEADERS_LIST_DATA](Leaders) {
    this.leadersListData = Leaders;
  }

  @Mutation
  [Mutations.LEADERS_LIST_SELECT_DATA](Leaders) {
    this.leadersListSelect = Leaders;
  }

  @Action
  [Actions.LEADERS_LIST_SELECT]() {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/leaders/get-all-select")
        .then((data) => {
          this.context.commit(Mutations.LEADERS_LIST_SELECT_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LEADERS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/leaders", payload)
        .then((data) => {
          this.context.commit(Mutations.LEADERS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LEADER_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("leaders/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.LEADERS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LEADER_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/leaders", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.LEADERS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LEADER_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/leaders", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.LEADERS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
